export const AUTH_USER_UPDATE = 'AUTH_USER_UPDATE'
export const AUTH_LOG_OUT = 'AUTH_LOG_OUT'
